import React from 'react'
import { Button, useModal } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import { useXrpl } from '../xrpl'
import WalletSelectModal from './WalletSelectModal'

const ConnectWalletButton = (props) => {
  const { t } = useTranslation()
  const { connecting } = useXrpl()
  const [onPresentWalletModal] = useModal(<WalletSelectModal />)

  return (
    <Button onClick={onPresentWalletModal} disabled={connecting} {...props}>
      {connecting ? t('Connecting...') : t('Connect Wallet')}
    </Button>
  )
}

export default ConnectWalletButton
